<template>
  <div class="w-full pt-5 pb-5">
    <div class="flex">
      <back-button
        label="Back"
        @onClick="$router.back()"
        variant="secondary"
        class="mr-4"
      />
      <div class="mt-4" style="border-left: 1px solid #878E99; height:1.5rem" />
      <div>
        <h1 class="text-xl mr-4 text-left font-extrabold ml-4 mt-3">
          {{$route.query.name}}
        </h1>
      </div>
      <div class="w-7/12 mt-4">
        <Breadcrumb
          @onClick="handleBreadcrumbClick($event)"
          :items="breadcrumbs"
        />
      </div>
    </div>

        <div style="height: 100%" v-if="loading">
      <loader size="xxs" :loader-image="false" />
    </div>

      <div class="px-3" v-else>
        <card class="p-5 mt-6">
          <div class="border rounded border-romanSilver border-dashed p-3">
            <p class="font-bold mb-5 text-lg">PAYE Information</p>
            <div class="flex w-full gap-3">
              <card class="p-3 w-auto">
                <h6 class=" uppercase mb-2 font-bold mb-2 text-xs font-black text-darkPurple">
                  IRS
                </h6>
                <h6 class="font-semibold text-sm text-jet uppercase">
                  {{ payeData.lirsName }}
                </h6>
              </card>
              <card class="p-3 ml-2">
                <div class="flex">

                  <div class="flex flex-col">
                    <h6 class="font-semibold mt-2 text-xs font-black text-blueCrayola uppercase">
                      Employer Tax Id Number
                    </h6>
                    <span
                      class="py-1 mr-4 capitalize font-semibold text-sm "
                    >
                      {{
                        payeData.lirsCode
                      }}
                    </span>
                  </div>
                </div>
              </card>
            </div>
            </div>

      <div class="mt-3">
        <div class="w-full flex mt-2 gap-5">
          <Card
            class="w-auto flex flex-grow text-white px-3 pt-6"
            style="background: #3454d1 !important"
          >
            <div class="flex flex-grow">

              <div class="flex flex-grow">
              <Icon class-name="text-white " icon-name="union" size="m" />

              <div class="flex flex-col flex-grow ml-4">
                <span class="font-black">Total PAYE deductions</span>
                <span class="text-lg font-bold">
                  {{
                    convertToCurrency(payeData.totalPayeDeduction)
                  }}</span
                >
              </div>
              </div>

              <div class="border bg-white w-0 mx-4 mb-4" />

            <div class="flex flex-grow">
              <Icon class-name="text-white " icon-name="union" size="m" />
              <div class="flex flex-col flex-grow ml-4">
                <span class="font-black">Total Remitted</span>
                <span class="text-lg font-bold">{{
                  convertToCurrency(payeData.totalRemitted)
                }}</span>
              </div>
              </div>

              <div class="border bg-white w-0 mx-4 mb-4" />

            <div class="flex flex-grow">
              <Icon class-name="text-white " icon-name="union" size="m" />
              <div class="flex flex-col flex-grow ml-4">
                <span class="font-black">Total Outstanding</span>
                <span class="text-lg font-bold">{{
                  convertToCurrency(payeData.totalOutstanding)
                }}</span>
              </div>
              </div>

            </div>
          </Card>

          <Card
            class="w-auto px-3 flex text-white"
            style="
              background: #13b56a !important;
              box-shadow: 0px 1px 2px rgba(45, 49, 66, 0.06),
                0px 1px 3px rgba(8, 7, 8, 0.1);
              border-radius: 8px;
            "
          >
            <Icon icon-name="employee_payrun" class-name="ml-4" size="m" />

            <div class="flex flex-col my-8 ml-6">
              <span class="font-semibold uppercase text-xs"
                >Taxable employees</span
              >
              <span class="font-bold text-lg pt-2">{{
                payeData.employeeCount
              }}</span>
            </div>
          </Card>
          </div>
        </div>

            </card>
            </div>

    <div class="px-3" v-if="!loading">
      <card class="p-5 mt-6 ">
        <template v-slot:footer>
          <CardFooter>
            <template v-slot:search>
              <SearchInput
                placeholder="Search"
                class="search"
                style="width : 300px; margin-top: 0.1rem;"
              />
            </template>
          </CardFooter>
        </template>
      </card>
      <div class="w-full mt-10">
            <sTable
              :headers="payeHeader"
              :items="payrunData"
              aria-label="pension table"
              class="w-full mt-1"
              :has-checkbox="false"
              :has-number="false"
              :loading="loading"
            >
              <template v-slot:item="{ item }">
                <div v-if="item.status">
                  <Badge
                    label="Remitted"
                    variant="primary"
                    background-color="rgba(19, 181, 106, 0.08)"
                    color="#13B56A"
                    style="padding: 8px; height: 33px; font-weight: 600; font-size: 14px"
                    v-if="item.data.status === 'paid'"
                  />
                  <Badge
                    label="Outstanding"
                    variant="primary"
                    background-color="rgba(234, 60, 83, 0.08)"
                    color="#EA3C53"
                    style="padding: 8px; height: 33px; font-weight: 600; font-size: 14px"
                    v-else
                  />
                </div>
                <div v-else-if="item.id">
                  <div
                    v-feature-request
                    @click="
                      $router.push({
                        name: 'ViewEmployeesPAYE',
                        params: { id: item.data.id, idNo: item.data.idNo },
                        query: {
                          name: $route.query.name,
                        }
                      })
                    "
                    class="cursor-pointer h-8 flex"
                  >
                    <icon
                      icon-name="icon-eye"
                      size="xsm"
                      class="-mt-1 -ml-2 text-blueCrayola"
                      style="padding: 3px 10px; width: 36px; height: 36px"
                    />
                  </div>
                </div>
              </template>
            </sTable>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PensionDetails",
  components: {
    Breadcrumb: () =>
      import("@scelloo/cloudenly-ui/src/components/bread-crumb"),
    Card: () => import("@/components/Card"),
    CardFooter: () => import("@/components/CardFooter"),
    SearchInput: () =>
      import("@scelloo/cloudenly-ui/src/components/search-input"),
    BackButton: () =>
      import("@scelloo/cloudenly-ui/src/components/back-button"),
    Icon: () => import("@/components/Icon"),
    STable: () => import("@scelloo/cloudenly-ui/src/components/table"),
    Badge: () => import("@scelloo/cloudenly-ui/src/components/badge"),
  },
  data() {
    return {
      breadcrumbs: [
        {
          disabled: false,
          text: "Payroll",
          href: "payroll",
          id: "Payroll"
        },
        {
          disabled: false,
          text: "Compliance",
          href: "PayRoll Pension",
          id: "pensions"
        },
        {
          disabled: false,
          text: "PAYE",
          href: "PAYE",
          id: "View Pension"
        },
        {
          disabled: false,
          text: this.$route.query.name,
          href: this.$route.query.name,
          id: "View Pension"
        },
      ],
      payeHeader: [
        { title: "Payrun Cycle", value: "payrunCycle" },
        { title: "Payrun Date", value: "payrunDate" },
        { title: "Payrun Id No", value: "idNo" },
        { title: "No of Employees", value: "employeesCount" },
        { title: "Total Paye Deducttions", value: "payeDeductions" },
        { title: "Status", value: "status" },
        { title: "", value: "id", image: true },
      ],
      payrunData: [],
      pfaData: {
        pfaName: "",
        pfaCode: ""
      },
      payeData: {
        lirsName: "",
        lirsCode: "",
        totalPayeDeduction: 0,
        totalRemitted: 0,
        totalOutstanding: 0,
        employeeCount: 0,
      },
      loading: true,
    };
  },
  methods: {
    resetDate(value) {
      if (value) {
        const dateValue = value;

        const split = dateValue.split("T00:00:00.000Z");

        return `${split[0]}T13:00:00.000Z`;
      }
      return "";
    },

    getCycleTax() {
      this.$_getCycleTaxAuthority(this.$route.params.id).then((response) => {
        const payrunData = response.data.payrunCycles;

        this.payeData.lirsName = response.data.taxAuthority.name;
        this.payeData.lirsCode = response.data.taxAuthority.tin.tin;
        this.payeData.totalPayeDeduction =
          response.data.summary.totalPayeDeduction;
        this.payeData.totalRemitted = response.data.summary.totalRemitted;
        this.payeData.totalOutstanding =
          response.data.summary.totalOutstanding;
        this.payeData.employeeCount = response.data.summary.employeeCount;

          payrunData.forEach((data) => {
            this.payrunData.push({
              id: this.$route.params.id,
              payrunCycle: `${this.$DATEFORMAT(
                new Date(`${data.payrun.year}-${data.payrun.month}-01`),
                `MMMM yyyy`
              )} Cycle`,
              payrunDate: data.payrun.paidAt ? `${this.$DATEFORMAT(
                new Date(`${data.payrun.paidAt}`),
                `MMMM dd, yyyy`
              )}` : `${this.$DATEFORMAT(
                new Date(this.resetDate(`${data.payrun.payDate}`)),
                `MMMM dd, yyyy`
              )}`,
              idNo: data.payrun.payrunNo,
              employeesCount: data.employeeCount,
              payeDeductions: `${this.convertToCurrency(
                data.totalPaye
              )}`,
              status: `${data.status}`,
            });
          });

          this.loading = false;
      })
      .catch(() => {
          this.loading = false;
        });
    },
    async viewRemittance() {
      try {
        await this.$handlePrivilege("pension", "viewCurrentPensionRemittance");
      } catch (error) {
        this.$router.push({ name: "ErrorRestricted" });
      }
    },
    async remitPension() {
      try {
        await this.$handlePrivilege("pension", "remittPension");
      } catch (error) {
        this.$toasted.error("You do not have permission to perform this task", {
          duration: 5000
        });
      }
    },
    handleBreadcrumbClick(event) {
      if (event === "ViewPension") {
        this.$router.push({
          name: event,
          query: { name: this.$route.query.name }
        });
      } else {
        this.$router.push({
          name: event
        });
      }
    }
  },
  async mounted() {
    this.getCycleTax();
  }
};
</script>

<style scoped>
.icon {
  width: 24px;
  height: 24px;
  padding: 3px;
}
</style>
